import React from 'react';

const EntryContext = React.createContext();

export default EntryContext;
